<template>
  <div class="varibale-container">
    <div class="card">
			<div class="btn-container">
				<div class="btn-style" :class="{'active': active == 'general'}" @click="changeTab('general')">一般设置</div>
				<div class="btn-style" :class="{'active': active == 'tts'}" @click="changeTab('tts')">语音合成</div>
				<div class="btn-style" :class="{'active': active == 'asr'}" @click="changeTab('asr')">语音识别</div>
				<div class="btn-style" v-if="access.flowLlm" :class="{'active': active == 'llm'}" @click="changeTab('llm')">llm</div>
				<div class="btn-style" :class="{'active': active == 'transfer'}" @click="changeTab('transfer')">转接配置</div>
				<div class="btn-style" :class="{'active': active == 'sms'}" @click="changeTab('sms')">短信配置</div>
				<div class="btn-style" :class="{'active': active == 'vars'}" @click="changeTab('vars')">自定义变量</div>
				<div class="btn-style" :class="{'active': active == 'ratings'}" @click="changeTab('ratings')">自定义评级</div>
				<div class="btn-style" :class="{'active': active == 'apiSettings'}" @click="changeTab('apiSettings')">接口配置</div>
				<div class="btn-style" :class="{'active': active == 'prologue'}" @click="changeTab('prologue')">多开场⽩设置</div>
			</div>
			<tts v-if="active === 'tts'"/>
			<asr v-if="active === 'asr'"/>
			<transfer v-if="active === 'transfer'"/>
			<sms v-if="active === 'sms'"/>
			<vars v-if="active === 'vars'"/>
			<general v-if="active === 'general'" />
			<ratings v-if="active === 'ratings'"/>
			<apiSettings v-if="active === 'apiSettings'"/>
			<prologue v-if="active === 'prologue'"/>
			<LLM v-if="active === 'llm'"/>
		</div>
  </div>
</template>

<script>
import Tts from './components/Tts';
import Asr from './components/Asr';
import Transfer from './components/Transfer';
import Sms from './components/Sms';
import Vars from './components/Vars';
import General from './components/General.vue';
import Ratings from './components/Ratings.vue';
import ApiSettings from './components/ApiSettings.vue';
import Prologue from './components/Prologue.vue';
import { mapState } from 'vuex';
import LLM from './components/LLM';

export default {
	components: {
		Tts,
		Asr,
		Transfer,
		Sms,
		Vars,
		General,
		Ratings,
		ApiSettings,
		Prologue,
		LLM,
	},
  data() {
		return {
			active: 'general',
		}
	},
	computed: {
    ...mapState('user', [
			"access"
    ]),
	},
	methods: {
		changeTab(index) {
			this.active = index
		}
	}
}
</script>

<style lang="scss" scoped>
.varibale-container{
	padding: 20px;
	.card{
		width: 100%;
		border: 1px solid #f3f3f3;
		text-align: left;
		padding: 20px;
		box-shadow: 2px 2px 20px #eee;
		.btn-container{
			border-radius: 40px;
			background-color: #eee;
			padding: 10px;
			.btn-style{
				display: inline-block;
				padding: 5px 20px;
				background-color: #eee;
				color: #999;
				margin-right: 20px;
				border-radius: 20px;
				cursor: pointer;
			}
			.active{
				background-color: #68a0e0;
				color: #fff;
			}
		}
	}
}
</style>